import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=5c34a09c"
import script from "./PermissionsTable.vue?vue&type=script&lang=js"
export * from "./PermissionsTable.vue?vue&type=script&lang=js"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&id=5c34a09c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports